import { styled, TextV2, keyframes, Flex, Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const MessageContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: ${props => props.height};
  height: fit-content;
`;

export const ContentContainer = styled(Flex)`
  width: 100%;
  flex-direction: column;
  gap: ${pxToRem(8)};
  padding-bottom: ${pxToRem(40)};
  height: fit-content;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const ButtonContainer = styled(Box)<{ isMobile?: boolean; show?: boolean }>`
  position: absolute;
  bottom: 0;
  left: ${({ isMobile }) => (isMobile ? '50%' : pxToRem(0))};
  transform: ${({ isMobile }) => (isMobile ? 'translateX(-50%)' : 'none')};
  z-index: 2;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  animation: ${fadeIn} 0.3s ease-in-out;
`;

export const FadeContainer = styled(Box)<{ show: boolean }>`
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 1.5s ease-in-out;
  position: ${({ show }) => (show ? 'relative' : 'absolute')};
  width: 100%;
  height: ${({ show }) => (show ? '100%' : '0')};
  pointer-events: ${({ show }) => (show ? 'auto' : 'none')};
  z-index: ${({ show }) => (show ? 1 : 0)};
  display: flex;
  align-items: center;
  min-height: inherit;
`;

const smoothGradientLoop = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

export const GradientText = styled(TextV2)`
  background: linear-gradient(
    270deg,
    color(display-p3 0.0471 0.6471 0.6) 0%,
    color(display-p3 0.2863 0.3176 0.9373) 25%,
    color(display-p3 0.7285 0.1667 0.7686) 50%,
    color(display-p3 0.2863 0.3176 0.9373) 75%,
    color(display-p3 0.0471 0.6471 0.6) 100%
  );
  background-size: 200% 200%;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${smoothGradientLoop} 6s ease-in-out infinite;
`;
